import { HistoryModel } from '../models/history.model';
import { SynchronizationModel } from 'src/app/story/models/synchronization.model';

export class HistoryStateModel {
    histories: HistoryModel[];
    current: number;

    cache: {
        [cacheId: string]: SynchronizationModel
    };
}
